import React, { useCallback, useEffect, useRef, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import {
  ShowError, confirmationDialog, DROPDOWN_LIST_NONE,
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
  JSON_KEY_SUBMITTER, ITEM_CREATE, ITEM_MODIFY, EVENT_TYPE_HOLDINGS_MODIFY, EVENT_TYPE_HOLDINGS_CREATE,
  JSON_KEY_AVAILABLE, JSON_KEY_TOTAL, JSON_KEY_SELL_PENDING_APPROVAL, JSON_KEY_BUY_PENDING_APPROVAL,
  JSON_KEY_TRADING_ACCOUNT, JSON_KEY_INSTRUMENT,
  INSTRUMENT_TYPE_NAME_CURRENCY,
  INSTRUMENT_TYPE_NAME_CRYPTO_CURRENCY,
  YES,
  ITEM_CLEAR_BUY_TRADE,
  EVENT_TYPE_HOLDINGS_CLEAR_TRADE,
  JSON_KEY_AMOUNT,
  JSON_KEY_VERB,
  BUY_SIDE,
  ITEM_CLEAR_SELL_TRADE,
  SELL_SIDE,
  JSON_KEY_UPDATE_TOTALS,
  EVENT_TYPE_HOLDINGS_ADJUST_BALANCES,
  ITEM_ADJUST_BALANCES,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTableData, selectTSUserId } from "../../redux/globalsSlice";
import { MSG_TYPE_HOLDINGS_ADJUST_BALANCES, MSG_TYPE_HOLDINGS_CLEAR_TRADE, MSGTYPE_HOLDINGS_CREATE, MSGTYPE_HOLDINGS_MODIFY, } from "../../common/msg_types";
import { RenderDropdown, InputField, To64BitIntFromPriceString, CleanNumber } from "../../common/utilies";
import { yesNoOptions } from "../../common/convert_functions";

const HoldingsAdminForm = ({ rowData, onClose, tradingAccountOptions, holdingsOptions }) => {
   const userId = useSelector(selectTSUserId);

   // acces to instruments table data for price decimals
   const instrumentsTableData = useSelector(selectTableData); // ✅ get full table data from redux
   const instrumentsTableDataRef = useRef({});
   const [updateTotals, setUpdateTotals] = useState(YES);
   const [delta, setDelta] = useState(0);

   const onYesNoDropDownChange = useCallback((e) => {setUpdateTotals(e.target.value)}, [setUpdateTotals]);
   
   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   // tab1
   const [tradingAccount, setTradingAccount] = useState(rowData?.tradingAccount);

   // tab 2
   const [holdings, setHoldings] = useState(DROPDOWN_LIST_NONE);
   const [total, setTotal] = useState(CleanNumber(rowData?.tot));
   const [available, setAvailable] = useState(CleanNumber(rowData?.avail));
   const [buyPending, setBuyPending] = useState(CleanNumber(rowData?.b_pend));
   const [sellPending, setSellPending] = useState(CleanNumber(rowData?.s_pend));
   
   // tab 3 & 4
   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   // Enhanced holdings change handler - resets all fields when holding changes
   const onHoldingsDropDownChange = useCallback((e) => {
      const newHolding = e.target.value;
      setHoldings(newHolding);
      
      // Reset all fields when holding changes
      setTotal(0);
      setAvailable(0);
      setBuyPending(0);
      setSellPending(0);
      setDelta(0);
      
      // Optionally, you could fetch existing data for the new holding here
      // if you want to populate fields with existing values
   }, [setHoldings, setTotal, setAvailable, setBuyPending, setSellPending, setDelta]);

   const onTradingAccountModifyDropDownChange = (e) => {
      setTradingAccount(e.target.value);
      setHoldings(DROPDOWN_LIST_NONE);
      setTotal(0);
      setAvailable(0);
      setBuyPending(0);
      setSellPending(0);
      setDelta(0);
   };
   
   useEffect(() => {
      instrumentsTableDataRef.current = instrumentsTableData;
   }, [instrumentsTableData]);

   const [decimals, setDecimals] = useState(0);
   const [step, setStep] = useState(0.0001);

   useEffect(() => {
      const instrumentRow = instrumentsTableDataRef.current[holdings];
      if (!instrumentRow) return;

      const type = instrumentRow?.i_type ?? 0;
      const dec = (type === INSTRUMENT_TYPE_NAME_CURRENCY || type === INSTRUMENT_TYPE_NAME_CRYPTO_CURRENCY) ? instrumentRow?.price_dec ?? 0 : instrumentRow?.qty_dec ?? 0;

      setDecimals(dec);
      setStep(1 / Math.pow(10, dec));
      console.log('holdings: ', holdings, 'dec: ', dec, ', step: ', step);
   }, [holdings, step, instrumentsTableDataRef]);

   const ConfirmAndSubmit = async ({ title, text, item }) => {
      const confirmed = await confirmationDialog({ title, text });
      if (confirmed) handleStatusConfirmationSubmit(item);
   };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const instrumentRow = instrumentsTableDataRef.current[holdings];
      if (!instrumentRow) return;

      const type = instrumentRow?.i_type ?? 0;
      const decimals = (type === INSTRUMENT_TYPE_NAME_CURRENCY || type === INSTRUMENT_TYPE_NAME_CRYPTO_CURRENCY)
                              ? instrumentRow?.price_dec ?? 0 : instrumentRow?.qty_dec ?? 0;

      const payload = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_TRADING_ACCOUNT]: tradingAccount,
         [JSON_KEY_INSTRUMENT]: holdings,
      };

      switch (submitItem) {
         case ITEM_CREATE:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_HOLDINGS_CREATE,
               {
                  ...payload,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_HOLDINGS_CREATE,
                  [JSON_KEY_TOTAL]: Number(To64BitIntFromPriceString(total, decimals)),
                  [JSON_KEY_AVAILABLE]: Number(To64BitIntFromPriceString(available, decimals)),
                  [JSON_KEY_SELL_PENDING_APPROVAL]: Number(To64BitIntFromPriceString(sellPending, decimals)),
                  [JSON_KEY_BUY_PENDING_APPROVAL]: Number(To64BitIntFromPriceString(buyPending, decimals)),
               }
            );
            break;

         case ITEM_MODIFY:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_HOLDINGS_MODIFY,
               {
                  ...payload,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_HOLDINGS_MODIFY,
                  [JSON_KEY_TOTAL]: Number(To64BitIntFromPriceString(total, decimals)),
                  [JSON_KEY_AVAILABLE]: Number(To64BitIntFromPriceString(available, decimals)),
                  [JSON_KEY_SELL_PENDING_APPROVAL]: Number(To64BitIntFromPriceString(sellPending, decimals)),
                  [JSON_KEY_BUY_PENDING_APPROVAL]: Number(To64BitIntFromPriceString(buyPending, decimals)),
               }
            );
            break;

         case ITEM_CLEAR_BUY_TRADE:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_HOLDINGS_CLEAR_TRADE,
               {
                  ...payload,
                  [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_HOLDINGS_CLEAR_TRADE,
                  [JSON_KEY_VERB]: BUY_SIDE,
                  [JSON_KEY_AMOUNT]: Number(To64BitIntFromPriceString(buyPending, decimals)),
                  [JSON_KEY_UPDATE_TOTALS]: updateTotals,
               }
            );
            break;

         case ITEM_CLEAR_SELL_TRADE:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_HOLDINGS_CLEAR_TRADE,
               {
                  ...payload,
                  [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_HOLDINGS_CLEAR_TRADE,
                  [JSON_KEY_VERB]: SELL_SIDE,
                  [JSON_KEY_AMOUNT]: Number(To64BitIntFromPriceString(sellPending, decimals)),
                  [JSON_KEY_UPDATE_TOTALS]: updateTotals,
               }
            );
            break;

            case ITEM_ADJUST_BALANCES:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_HOLDINGS_ADJUST_BALANCES,
               {
                  ...payload,
                  [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_HOLDINGS_ADJUST_BALANCES,
                  [JSON_KEY_AMOUNT]: Number(To64BitIntFromPriceString(delta, decimals)),
               }
            );
            break;

            default:
            console.log("HoldingsAdminForm unknown submit item");
      }
   };

   const ValidateFields = () => {
      if (!tradingAccount) return "Code is missing";
      if (!total) return "Total is missing";
      if (!available) return "Available is missing";
      if (!holdings) return "Holdings is missing";
      return null;
   };

   const handleClearBuySubmit = () => {
      if (!tradingAccount) return ShowError("Code is missing");
      if (!holdings) return "Holdings is missing";
      if (!buyPending) return ShowError("Buy Pending is missing");

      ConfirmAndSubmit({
         title: "Clearing Buy Trade",
         text: `Clearing Buy Trade for: ${tradingAccount}`,
         item: ITEM_CLEAR_BUY_TRADE,
      });
      onClose(); // your modal close function
   };

   const handleClearSellSubmit = () => {
      if (!tradingAccount) return ShowError("Code is missing");
      if (!holdings) return "Holdings is missing";
      if (!sellPending) return ShowError("Sell Pending is missing");

      ConfirmAndSubmit({
         title: "Clearing Sell Trade",
         text: `Clearing Sell Trade for: ${tradingAccount}`,
         item: ITEM_CLEAR_SELL_TRADE,
      });
      onClose(); // your modal close function
   };

   const handleAdjustBalancesSubmit = () => {
      if (!tradingAccount) return ShowError("Code is missing");
      if (!holdings) return "Holdings is missing";
      if ((delta === 0) || (delta === undefined)) return ShowError("Delta must be non zero");

      ConfirmAndSubmit({
         title: "Adjusting Balannces",
         text: `Adjust Balances for: ${tradingAccount}`,
         item: ITEM_ADJUST_BALANCES,
      });
      onClose(); // your modal close function
   };

   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Create Holdings",
         text: `Creating new holdings: ${tradingAccount}`,
         item: ITEM_CREATE,
      });
      onClose(); // your modal close function
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Modify Holdings",
         text: `Modifying holdings: ${tradingAccount}`,
         item: ITEM_MODIFY,
      });
      onClose(); // your modal close function
   };

   useEffect(() => {
      if (!rowData) return;
         setTradingAccount(rowData.trdacc || '');
         setHoldings(rowData.instr || '');
         // Also reset fields when rowData changes
         setTotal(CleanNumber(rowData?.tot) || 0);
         setAvailable(CleanNumber(rowData?.avail) || 0);
         setBuyPending(CleanNumber(rowData?.b_pend) || 0);
         setSellPending(CleanNumber(rowData?.s_pend) || 0);
         setDelta(0);
   }, [rowData]);

   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Holdings Administration</h2>
         <Tabs forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Modify Holdings (Debug)</Tab>
               <Tab>Create Holdings</Tab>
               <Tab>Clear Buy Trade</Tab>
               <Tab>Claer Sell Trade</Tab>
               <Tab>Adjust Balances</Tab>
            </TabList>

            {/* Tab 1: Modify Holdings. Note white space with no new line \u00A0 */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>
               <div className="top">
                  {RenderDropdown("Trading\u00A0Account", tradingAccount, tradingAccountOptions, onTradingAccountModifyDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Holdings", holdings, holdingsOptions, onHoldingsDropDownChange)}
               </div>

               <div>
                  <InputField label="Total" value={total} onChange={setTotal} type="number" step={step} decimals={decimals} min={0} />
               </div>

               <div>
                  <InputField label="Available" value={available} onChange={setAvailable} type="number" step={step} decimals={decimals}  min={0}/>
               </div>

               <div>
                  <InputField label="Buy Pending" value={buyPending} onChange={setBuyPending} type="number" step={step} decimals={decimals}  min={0}/>
               </div>

               <div>
                  <InputField label="Sell Pending" value={sellPending} onChange={setSellPending} type="number" step={step} decimals={decimals}  min={0}/>
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
            
            {/* Tab 2: Create Holdings */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>
               <div className="top">
                  {RenderDropdown("Trading\u00A0Account", tradingAccount, tradingAccountOptions, onTradingAccountModifyDropDownChange)}
               </div>
               
               <div className="top">
                  {RenderDropdown("Holdings", holdings, holdingsOptions, onHoldingsDropDownChange)}
               </div>

               <div>
                  <InputField label="Total" value={total} onChange={setTotal} type="number"  step={step} decimals={decimals} min={0}/>
               </div>

               <div>
                  <InputField label="Available" value={available} onChange={setAvailable} type="number"  step={step} decimals={decimals} min={0}/>
               </div>

               <div>
                  <InputField label="Buy Pending" value={buyPending} onChange={setBuyPending} type="number"  step={step} decimals={decimals} min={0}/>
               </div>

               <div>
                  <InputField label="Sell Pending" value={sellPending} onChange={setSellPending} type="number"  step={step} decimals={decimals} min={0}/>
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 3: Clear Buy Trade */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleClearBuySubmit)}>
               <div className="top">
                  {RenderDropdown("Trading\u00A0Account", tradingAccount, tradingAccountOptions, onTradingAccountModifyDropDownChange)}
               </div>
               
               <div className="top">
                  {RenderDropdown("Holdings", holdings, holdingsOptions, onHoldingsDropDownChange)}
               </div>

               <div>
                  <InputField label="Buy Pending" value={buyPending} onChange={setBuyPending} type="number"  step={step} decimals={decimals} min={0}/>
               </div>

               <div className="top">
                  {RenderDropdown("Update Totals", updateTotals, yesNoOptions, onYesNoDropDownChange)}
               </div>  

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>


            {/* Tab 4: Clear Sell Trade */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleClearSellSubmit)}>
               <div className="top">
                  {RenderDropdown("Trading\u00A0Account", tradingAccount, tradingAccountOptions, onTradingAccountModifyDropDownChange)}
               </div>
               
               <div className="top">
                  {RenderDropdown("Holdings", holdings, holdingsOptions, onHoldingsDropDownChange)}
               </div>

               <div>
                  <InputField label="Sell Pending" value={sellPending} onChange={setSellPending} type="number"  step={step} decimals={decimals} min={0}/>
               </div>

               <div className="top">
                  {RenderDropdown("Update Totals", updateTotals, yesNoOptions, onYesNoDropDownChange)}
               </div>  

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 5: Adjust Balances */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleAdjustBalancesSubmit)}>
               <div className="top">
                  {RenderDropdown("Trading\u00A0Account", tradingAccount, tradingAccountOptions, onTradingAccountModifyDropDownChange)}
               </div>
               
               <div className="top">
                  {RenderDropdown("Holdings", holdings, holdingsOptions, onHoldingsDropDownChange)}
               </div>

               <div>
                  <InputField label="Delta" value={delta} onChange={setDelta} type="number" step={step} decimals={decimals}/>
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

         </Tabs>
         </div>
      </div>
   );
};

export default HoldingsAdminForm;